import React from "react";

export const SparkleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4286 5.14286L14.6143 3.38571L12.8571 2.57143L14.6143 1.75714L15.4286 0L16.2429 1.75714L18 2.57143L16.2429 3.38571L15.4286 5.14286ZM5.57143 5.14286L4.75714 3.38571L3 2.57143L4.75714 1.75714L5.57143 0L6.38571 1.75714L8.14286 2.57143L6.38571 3.38571L5.57143 5.14286ZM15.4286 15L14.6143 13.2429L12.8571 12.4286L14.6143 11.6143L15.4286 9.85714L16.2429 11.6143L18 12.4286L16.2429 13.2429L15.4286 15ZM2.65714 17.7429L0.257143 15.3429C0.0857143 15.1714 0 14.9643 0 14.7214C0 14.4786 0.0857143 14.2714 0.257143 14.1L9.81429 4.54286C9.98571 4.37143 10.1929 4.28571 10.4357 4.28571C10.6786 4.28571 10.8857 4.37143 11.0571 4.54286L13.4571 6.94286C13.6286 7.11429 13.7143 7.32143 13.7143 7.56429C13.7143 7.80714 13.6286 8.01429 13.4571 8.18571L3.9 17.7429C3.72857 17.9143 3.52143 18 3.27857 18C3.03571 18 2.82857 17.9143 2.65714 17.7429ZM3.3 15.9429L9.42857 9.77143L8.22857 8.57143L2.05714 14.7L3.3 15.9429Z"
      fill="white"
    />
  </svg>
);
